export default __webpack_public_path__ + "media/assets/fonts/roboto-v20-latin-700italic-ea7a3036ad9539366729b18d85106cd0.svg";